import React from 'react';
import classnames from 'classnames';


export default ({children, large}) => (
  <div className="pop-up">
    <div className={classnames({
      "pop-up__container": true,
      "pop-up__container--large": large
    })}>
      {children}
    </div>
  </div>
);
